//added by heliang 20240815 添加会员储值卡密
import fetch from '../utils/fetch'

export function saveSetting(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'post',
    params: query
  })
}

export function getSettingList(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'get',
    params: query
  })
}

export function getSettingInfo(id) {
  return fetch({
    url: '/selfhelp/formdata/' + id,
    method: 'get'
  })
}

export function updateSetting(query) {
  return fetch({
    url: '/selfhelp/formdata',
    method: 'put',
    params: query
  })
}

export function deleteSetting(id) {
  return fetch({
    url: '/selfhelp/formdata/discard/' + id,
    method: 'post'
  })
}

export function restoreSetting(id) {
  return fetch({
    url: '/selfhelp/formdata/restore/' + id,
    method: 'post'
  })
}

export function saveTemplate(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'post',
    params: query
  })
}

export function getTemplateList(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'get',
    params: query
  })
}

export function getTemplateInfo(id) {
  return fetch({
    url: '/selfhelp/formtem/' + id,
    method: 'get'
  })
}

export function updateTemplate(query) {
  return fetch({
    url: '/selfhelp/formtem',
    method: 'put',
    params: query
  })
}

export function deleteTemplate(id) {
  return fetch({
    url: '/selfhelp/formtem/discard/' + id,
    method: 'post'
  })
}

export function restoreTemplate(id) {
  return fetch({
    url: '/selfhelp/formtem/restore/' + id,
    method: 'post'
  })
}

export function physicalFirst() {
  return fetch({
    url: '/selfhelp/setting/physical',
    method: 'get'
  })
}

export function physicalNormal(query) {
  return fetch({
    url: '/selfhelp/setting/physical',
    method: 'post',
    params: query
  })
}

export function allUserList(query) {
  return fetch({
    url: '/selfhelp/physical/alluserlist',
    method: 'get',
    params: query
  })
}

export function allUserData(query) {
  return fetch({
    url: '/selfhelp/physical/userdata',
    method: 'get',
    params: query
  })
}

export function timeData(query) {
  return fetch({
    url: '/selfhelp/physical/datelist',
    method: 'get',
    params: query
  })
}

// 储值卡密列表
export function regCardpasswordList(query) {
  return fetch({
    url: '/promotions/cardpassword/list',
    method: 'get',
    params: query
  })
}

// 储值卡密清单列表
export function regCardpasswordItemList(query) {
  return fetch({
    url: '/promotions/cardpassword/item_list',
    method: 'get',
    params: query
  })
}

// 储值卡密清单列表导出
export function cardpasswordItemExport(query) {
  return fetch({
    url: '/promotions/cardpassword/item_list_export',
    method: 'get',
    params: query
  })
}

export function regActivityEasylist(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/easylist',
    method: 'get',
    params: query
  })
}

//储值卡密新增
export function regCardpasswordAdd(query) {
  return fetch({
    url: '/promotions/cardpassword/create',
    method: 'post',
    params: query
  })
}

//储值卡密查询列表
export function regCardpasswordGet(query) {
  return fetch({
    url: '/promotions/cardpassword/get',
    method: 'get',
    params: query
  })
}
//储值卡密修改
export function regCardpasswordUpdate(query) {
  return fetch({
    url: '/promotions/cardpassword/update',
    method: 'put',
    params: query
  })
}

//储值卡密发行
export function regCardpasswordIssue(query) {
  return fetch({
    url: '/promotions/cardpassword/issue',
    method: 'post',
    params: query
  })
}

// 活动
export function regActivityInvalid(query) {
  return fetch({
    url: '/selfhelp/registrationActivity/invalid',
    method: 'post',
    params: query
  })
}
//储值卡密删除
export function regCardpasswordDel(query) {
  return fetch({
    url: '/promotions/cardpassword/del',
    method: 'post',
    params: query
  })
}

export function regActivityRecordlist(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/list',
    method: 'get',
    params: query
  })
}
export function regActivityRecordinfo(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/get',
    method: 'get',
    params: query
  })
}

export function recordExport(query) {
  return fetch({
    url: '/selfhelp/registrationRecord/export',
    method: 'get',
    params: query
  })
}
export function registrationReview(query) {
  return fetch({
    url: '/selfhelp/registrationReview',
    method: 'put',
    params: query
  })
}
